<template>
  <div class="playlet">
    <el-card v-if="activeName == '1'" shadow="never">
      <div class="ndawerbox">
        <div style="display: flex;align-items: center;">
          <el-input
            v-model="parameter.title"
            style="width:200px;margin-right:10px"
            placeholder="请输入标题"
          />
          <el-select v-model="parameter.audit_status" placeholder="请选择状态" style="margin-right:10px">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-input
            v-model="parameter.admin_name"
            style="width:200px;margin-right:10px"
            placeholder="请输入管理员"
          />
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
          <el-button
            type="primary"
            style="margin-left:10px"
            icon="el-icon-search"
            @click="sraw"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh"
            @click="reset"
          >重置</el-button>
          <div style="margin-left: 20px;">
            <el-row type="flex" align="middle" :gutter="5">
              <el-col v-for="(item, index) in by_rejecting_group" :key="index" :span="null">
                <el-tag
                  :type="getTagType(item.audit_status)"
                  effect="light"
                  disable-transitions
                >
                  {{ item.audit_status_text }}：{{ item.count }}
                </el-tag>
              </el-col>
            </el-row>
          </div>
        </div>
        <el-button
          size="mini"
          type="success"
          icon="el-icon-s-help"
          @click="add"
        >创建</el-button>
      </div>
    </el-card>
    <el-card v-if="activeName == '2'" shadow="never">
      <div style="display: flex;align-items: center;">
        <el-input
          v-model="twoparameter.admin_name"
          style="width:200px;margin-right:10px"
          placeholder="请输入标题"
        />
        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="srawtwo"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="resettwo"
        >重置</el-button>
      </div>
    </el-card>
    <el-card shadow="never">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="素材提交" name="1">
          <div>
            <el-table
              v-loading="loading"
              :data="tableData"
              border
              style="width: 100%"
            >
              <!-- <el-table-column
            prop="page_h5_no"
            label="编号"
            width="250"
            align="center"
            show-overflow-tooltip
          /> -->
              <el-table-column
                prop="title"
                label="标题"
                width="200"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.title"
                    placement="top"
                  >
                    <div style="font-size: 18px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 100%;">
                      {{ scope.row.title }}
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <!-- <el-table-column
            prop="content"
            label="文本"
            width="150"
            align="center"
            show-overflow-tooltip
          /> -->
              <el-table-column
                prop="content"
                label="文本"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <!-- {{ scope.row.content }} -->
                  <el-button
                    v-if="scope.row.content"
                    type="text"
                    @click="showContent(scope.row.content)"
                  >
                    查看文本
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="imgs"
                label="图片"
                width="300"
                align="center"
              >
                <template slot-scope="scope">
                  <!-- <img v-if="scope.row.imgs_with_domain[0]" :src="scope.row.imgs_with_domain[0]" style="width: 100px;height: 100px;" alt="" srcset=""> -->
                  <!-- <div @click="showImages(scope.row.imgs_with_domain)">
                <el-image
                  v-if="scope.row.imgs_with_domain[0]"
                  style="width: 100px; height: 100px"
                  :src="scope.row.imgs_with_domain[0]"
                  :fit="'contain'"
                />
              </div> -->
                  <el-image
                    v-if="scope.row.imgs_with_domain[0]"
                    style="width: 200px; height: 200px"
                    :src="scope.row.imgs_with_domain[0]"
                    :fit="'contain'"
                    :preview-src-list="scope.row.imgs_with_domain"
                  />
                  <!-- :preview-src-list="scope.row.imgs_with_domain" -->
                  <!-- <el-button
                type="text"
                @click="showImages(scope.row.imgs_with_domain)"
              >
                查看图片
              </el-button> -->
                </template>
              </el-table-column>
              <!-- <el-table-column
            prop="page_url"
            label="落地页地址"
            width="500"
            align="center"
          >
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;justify-content:center">
                <div>{{ scope.row.page_url }}</div>
                <div
                  class="copy_icon"
                  @click="copy(scope.row)"
                ><i
                  style="cursor: pointer;margin-left: 2px;"
                  class="el-icon-document-copy"
                /></div>
              </div>
            </template>
          </el-table-column> -->
              <el-table-column
                prop="audit_status"
                label="审核状态"
                align="center"
                width="150"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.audit_status === 1" style="color:gray;">
                    <i class="el-icon-time" /> 未审核
                  </span>
                  <span v-else-if="scope.row.audit_status === 2" style="color:#409EFF;">
                    <i class="el-icon-loading" /> 审核中
                  </span>
                  <span v-else-if="scope.row.audit_status === 3" style="color:#67C23A;">
                    <i class="el-icon-success" /> 审核通过
                  </span>
                  <span v-else-if="scope.row.audit_status === 4" style="color:#F56C6C;">
                    <i class="el-icon-error" /> 审核失败
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="audit_msg"
                label="审核信息"
                width="300"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                prop="admin_name"
                label="管理员名称"
                width="100"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                prop="created_at_text"
                label="创建时间"
                width="200"
                align="center"
              />
              <el-table-column
                label="操作"
                align="center"
                fixed="right"
              >
                <template scope="scope">
                  <el-button
                    type="warning"
                    size="small"
                    @click="edit(scope.row)"
                  >编辑</el-button>
                  <el-button
                    type="danger"
                    size="small"
                    @click="myDelete(scope.row.id)"
                  >删除</el-button>
                  <!-- <el-button
                type="primary"
                size="small"
                @click="openStatusDialog(scope.row)"
              >修改状态</el-button> -->
                  <el-button
                    type="success"
                    size="small"
                    @click="openStatusDialogdqwe(scope.row,3)"
                  >审核通过</el-button>
                  <el-button
                    type="danger"
                    size="small"
                    @click="openStatusDialogdqwebaer(scope.row)"
                  >审核失败</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <pagination-right
            :total="total"
            @size-change="fetchPageSize"
            @current-change="fetchCurrentPage"
          />
        </el-tab-pane>
        <el-tab-pane label="提交统计" name="2">
          <!-- <el-table
            v-loading="newloading"
            :data="newtableData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="created_by"
              label="created_by"
              align="center"
            />
            <el-table-column
              prop="nickname"
              label="人员姓名"
              align="center"
            />
            <el-table-column
              label="操作"
              align="center"
            >
              <template scope="scope">
                <el-button
                  type="warning"
                  size="small"
                  @click="editlook(scope.row)"
                >查看</el-button>
              </template>
            </el-table-column>
          </el-table> -->

          <div class="user-card-container">
            <div
              v-for="(user, index) in newtableData"
              :key="index"
              class="user-card"
              @click="editlook(user)"
            >
              <div class="user-avatar">
                <el-avatar icon="el-icon-user" size="large" />
              </div>
              <div class="user-name">{{ user.nickname }}</div>
            </div>
          </div>

        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog
      title="落地页H5"
      :visible.sync="cookiedialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="30%"
    >
      <dowloaddialog
        ref="sourdialogview"
        @updata="updatar"
      />
    </el-dialog>

    <el-dialog
      title="文本查看"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <div style="max-height: 400px;overflow: auto;white-space: pre-wrap;">
        <!-- {{ dialogContent }} -->
        <div v-html="dialogContent" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 图片弹窗 -->
    <el-dialog
      title="图片查看"
      :visible.sync="imgDialogVisible"
      :width="dialogWidth"
      top="5vh"
      :before-close="() => imgDialogVisible = false"
    >
      <div
        style="
      max-height: 80vh;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      padding: 10px;
    "
      >
        <img
          v-for="(img, idx) in dialogImgs"
          :key="idx"
          :src="img"
          style="max-width: 90vw; height: auto; border-radius: 4px;"
          @load="onImageLoad($event, idx)"
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改审核状态"
      :visible.sync="statusDialogVisible"
      width="400px"
    >
      <el-form label-width="80px">
        <el-form-item label="状态">
          <el-select v-model="selectedStatus" placeholder="请选择状态">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmStatusChange">确定</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗 -->
    <el-dialog
      title="请输入驳回原因"
      :visible.sync="failDialogVisible"
      width="500px"
      @close="failReason = ''"
    >
      <el-form :model="{ failReason }" label-width="80px">
        <el-form-item label="驳回原因">
          <el-input
            v-model="failReason"
            type="textarea"
            placeholder="请输入原因"
            :rows="4"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="failDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitFailReason">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dowloaddialog from './components/dowloaddialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { landingPageH5index, landingPageH5destroy, landingPageH5setAuditStatus, landingPageH5memberlist } from '@/api/publicPlan.js'
export default {
  name: 'WechatGame',
  components: {
    PaginationRight,
    dowloaddialog
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10,
        title: '',
        audit_status: '',
        start_date: '', // 单独的开始
        end_date: '', // 单独的结束
        admin_name: ''
      },
      twoparameter: {
        page: 1,
        page_size: 10,
        admin_name: ''
      },
      newtotal: null,
      newloading: false,
      newtableData: [],
      date: [], // [ '2025-07-01', '2025-07-05' ]
      loading: false,
      tableData: [],
      total: null,
      cookiedialogVisible: false,
      dialogVisible: false,
      dialogContent: '',
      imgDialogVisible: false,
      dialogImgs: [],

      statusDialogVisible: false,
      selectedStatus: null,
      currentRow: null,
      statusOptions: [
        { value: 1, label: '未审核' },
        { value: 2, label: '审核中' },
        { value: 3, label: '审核通过' },
        { value: 4, label: '审核失败' }
      ],
      dialogWidth: null,
      failDialogVisible: false,
      failReason: '',
      erid: null,
      activeName: '1',
      by_rejecting_group: []
    }
  },
  watch: {
    date(newVal) {
      if (newVal && newVal.length === 2) {
        this.parameter.start_date = newVal[0]
        this.parameter.end_date = newVal[1]
      } else {
        this.parameter.start_date = ''
        this.parameter.end_date = ''
      }
    }
  },
  created() {
    this.getDatas()
  },
  activated() {
    this.getDatas()
  },
  mounted() {},
  methods: {
    add() {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(1)
      })
    },
    edit(item) {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(2, item)
      })
    },
    async getDatas() {
      this.loading = true
      const data = await landingPageH5index(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      this.by_rejecting_group = data.data.by_rejecting_group
      this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    // 删除
    myDelete(id) {
      console.log('id', id)
      this.$confirm('此操作将删除落地页, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          landingPageH5destroy({
            id: id
          }).then(res => {
            this.getDatas()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    sraw() {
      this.parameter.page = 1
      this.getDatas()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        title: '',
        audit_status: '',
        start_date: '', // 单独的开始
        end_date: '', // 单独的结束
        admin_name: ''
      }
      this.date = []
      this.getDatas()
    },
    srawtwo() {
      this.twoparameter.page = 1
      this.getDatastwo()
    },
    // 重置
    resettwo() {
      this.twoparameter = {
        page: 1,
        page_size: 10,
        admin_name: ''
      }
      this.getDatastwo()
    },
    getDatastwo() {
      this.newloading = true
      landingPageH5memberlist(this.twoparameter).then((res) => {
        console.log('res', res)
        this.newloading = false
        this.newtableData = res.data.list
      })
    },
    updatar() {
      this.cookiedialogVisible = false
      this.getDatas()
    },
    copy(data) {
      const newdata = data.page_url
      if (navigator.clipboard) {
        console.log(1)
        navigator.clipboard.writeText(newdata)
      } else {
        const dummyInput = document.createElement('textarea')
        dummyInput.value = newdata
        dummyInput.style.left = '-9999px'
        dummyInput.style.top = '-9999px'
        dummyInput.style.textAlign = 'left'
        dummyInput.style.whiteSpace = 'pre-line'
        document.body.appendChild(dummyInput)
        dummyInput.select()
        document.execCommand('copy')
        document.body.removeChild(dummyInput)
      }
      this.$message.success('复制成功')
    },
    showContent(content) {
      this.dialogContent = content
      this.dialogVisible = true
    },
    showImages(imgs) {
      this.dialogImgs = imgs
      this.imgDialogVisible = true
    },
    openStatusDialog(row) {
      this.currentRow = row
      this.selectedStatus = row.audit_status // 预选
      this.statusDialogVisible = true
    },
    confirmStatusChange() {
      landingPageH5setAuditStatus({
        id: this.currentRow.id,
        audit_status: this.selectedStatus
      }).then((res) => {
        this.statusDialogVisible = false
        this.getDatas()
        this.$message.success('修改成功！')
      })
    },
    openStatusDialogdqwe(row, type) {
      landingPageH5setAuditStatus({
        id: row.id,
        audit_status: type
      }).then((res) => {
        this.getDatas()
        this.$message.success('修改成功！')
      })
    },
    openStatusDialogdqwebaer(row) {
      this.erid = row.id
      this.failDialogVisible = true
    },
    submitFailReason() {
      if (!this.failReason.trim()) {
        this.$message.error('请输入驳回原因')
        return
      }
      landingPageH5setAuditStatus({
        id: this.erid,
        audit_status: 4,
        audit_msg: this.failReason
      }).then((res) => {
        this.failDialogVisible = false
        this.failReason = ''
        this.getDatas()
        this.$message.success('修改成功！')
      })
    },
    onImageLoad(e, idx) {
    // 只在第一张图片加载完成时更新
      if (idx === 0) {
        const imgWidth = e.target.naturalWidth
        const maxWidth = window.innerWidth * 0.9
        this.dialogWidth = imgWidth > maxWidth ? `${maxWidth}px` : `${imgWidth}px`
      }
    },
    handleClick(tab, event) {
      console.log(tab.name, event)
      // eslint-disable-next-line eqeqeq
      if (tab.name == 1) {
        this.getDatas()
      } else {
        console.log('222')
        this.getDatastwo()
      }
    },
    getTagType(status) {
      switch (status) {
        case 1: return 'info' // 灰色
        case 3: return 'success' // 绿色
        case 4: return 'danger' // 红色
        default: return ''
      }
    },
    editlook(item) {
      console.log('item', item)
      this.$router.push({ path: '/dowloadhfivedetail/index', query: { created_by: item.created_by }})
    }
  }
}
</script>

<style scoped>
.playlet {
  margin: 30px;
  width: 98%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-card {
  height: 70px;
}
.copy_icon {
  margin-left: 10px;
}
.ndawerbox{
  display: flex;
  justify-content: space-between;
  /* margin-bottom: 10px; */
}
/deep/ .el-icon-circle-close {
  color: white !important;
}
.user-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  cursor: pointer;
}

.user-card {
  width: 200px;
  height: 108px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  /* flex-direction: column; */
  justify-content: center;
  background: #fff;
  transition: box-shadow 0.2s;
}

.user-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.user-avatar {
  /* margin-bottom: 8px; */
  margin-right: 15px;
  /* width: 64px;
  height: 64px; */
  border-radius: 8px;
}

.user-name {
  font-size: 14px;
  color:  black;
}
</style>

